import { Component, Inject, inject, OnInit } from "@angular/core";
import { DynamicFormService } from "../../../../../../shared/components/dynamic-forms-components/dynamic-form.service";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { UntypedFormGroup } from "@angular/forms";
import { FieldConfig } from "../../../../../../shared/components/dynamic-forms-components/field.interface";
import * as fromConfigs from "./warehouse-zone-add.form";
import { Store } from "@ngrx/store";
import { AppState } from "../../../../../../store";
import { StoreItemActions } from "../../../../../../store/entities/store-item/store-item.actions";
import { StoreItemEntity } from "../../../../../../store/entities/store-item/store-item.model";
import { REGISTER_ZONE_MUTATION, UPDATE_ZONE_MUTATION } from "../../../../../../store/entities/warehouse-management/building-zone/building-zone.graphql";
import { ActivatedRoute } from "@angular/router";

@Component({
  selector: "app-warehouse-zone-add",
  templateUrl: "./warehouse-zone-add.component.html",
  styleUrl: "./warehouse-zone-add.component.scss",
})
export class WarehouseZoneAddComponent implements OnInit {
  private dynamicFormService: DynamicFormService = inject(DynamicFormService);
  private dialogRef: MatDialogRef<WarehouseZoneAddComponent> = inject(
    MatDialogRef<WarehouseZoneAddComponent>
  );
  
  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private store: Store<AppState>,
    private route: ActivatedRoute
  ) {
  }

  supportForm: UntypedFormGroup;

  buildingZoneFields: FieldConfig[] = fromConfigs.buildingZoneFields;
  title: string;
  loading: boolean = false;
  warehouseId: string;
  id

 ngOnInit(): void {

  const fromDialog = this.data?.warehouse;

  const fromRouteParam =
    this.route.parent?.snapshot.params["uniqueId"] ||
    this.route.snapshot.queryParams["id"];

  this.warehouseId = fromDialog || fromRouteParam;

  console.log("Resolved Warehouse ID:", this.warehouseId);

  this.supportForm = this.dynamicFormService.createControl(
    this.buildingZoneFields,
    this.data
  );
}
  
  createZone = (formValue) =>{
     this.store.dispatch(
      StoreItemActions.createUpdateStoreItem({
        entity: StoreItemEntity.zone,
        mutation: REGISTER_ZONE_MUTATION,
        input: {
          ...formValue,
            warehouse: this.warehouseId,
        },
        isInput: true,
      })
    );
  }
  updateZone = (formValue) =>{
    this.store.dispatch(
     StoreItemActions.createUpdateStoreItem({
       entity: StoreItemEntity.zone,
       mutation: UPDATE_ZONE_MUTATION,
       input: {
         ...formValue,
         uniqueId:this.data.uniqueId,
          warehouse: this.warehouseId,
       },
       isInput: true,
     })
   );
 }

  async submitForm(formValue: any) {
    this.data?.uniqueId?this.updateZone(formValue):this.createZone(formValue)
  }

  closeDialog() {
    this.dialogRef.close();
  }
}
